import React from 'react';

import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import { store } from './store';
import { ToastContainer } from './components/Toast';
import App from './App';
import './sass/main.scss';

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
    <React.StrictMode>
        <Provider store={store}>
            <ToastContainer />
            <App />
        </Provider>
    </React.StrictMode>
);
